import script from "./FormInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormInput.vue?vue&type=script&lang=ts&setup=true"

import "./FormInput.vue?vue&type=style&index=0&id=36c08f5b&scoped=true&lang=css"

import exportComponent from "/Users/nana/LFMG/ionic-apps/vxt-ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c08f5b"]])

export default __exports__